const createCollabsSlider = () => {
    new Swiper('.collabs-slider', {
        slidesPerView: 1.5,
        scrollbar: {
            el: ".collabs-slider-scrollbar",
        },
        breakpoints: {
            640: {
                slidesPerView: 4,
            }
        }
    });
}

createCollabsSlider();
document.addEventListener("shopify:section:load", createCollabsSlider);